import { useMemo, useState } from 'react';

import {
  AppBottomSheet,
  AppBottomSheetHeader,
  AppButton,
  AppText,
} from '../../ui-foundation';
import { AppPanelButton } from '../../ui-foundation/adapters/web';
import {
  DISCREET_SHORTCUTS_SUBTITLE,
  DISCREET_SHORTCUTS_TITLE,
  DISCREET_SHORTCUTS_TRIGGER_LABEL,
  getVisibleDiscreetShortcutItems,
  type DiscreetShortcutItem,
} from '../../ui-foundation/features/shortcuts';

type ActionableShortcutItem = DiscreetShortcutItem & {
  onPress: () => void;
};

export default function SectionShortcutsLauncher({
  items,
  title = DISCREET_SHORTCUTS_TITLE,
  subtitle = DISCREET_SHORTCUTS_SUBTITLE,
  triggerLabel = DISCREET_SHORTCUTS_TRIGGER_LABEL,
}: {
  items: ActionableShortcutItem[];
  title?: string;
  subtitle?: string;
  triggerLabel?: string;
}) {
  const [open, setOpen] = useState(false);
  const visibleItems = useMemo(() => getVisibleDiscreetShortcutItems(items), [items]);

  if (!visibleItems.length) {
    return null;
  }

  return (
    <>
      <AppButton type="button" tone="outline" size="sm" onPress={() => setOpen(true)}>
        {triggerLabel}
      </AppButton>

      {open ? (
        <AppBottomSheet onClose={() => setOpen(false)} surfaceClassName="max-h-[70vh] overflow-y-auto">
          <AppBottomSheetHeader title={title} subtitle={subtitle} />
          <div className="space-y-2 p-4">
            {visibleItems.map((item) => (
              <AppPanelButton
                key={item.id}
                onClick={() => {
                  item.onPress();
                  setOpen(false);
                }}
                className="rounded-2xl border border-border bg-card px-4 py-3"
              >
                <div className="space-y-1 text-left">
                  <AppText fontSize="$sm" fontWeight="700">
                    {item.label}
                  </AppText>
                  <AppText fontSize="$xs" color="$colorMuted">
                    {item.description}
                  </AppText>
                </div>
              </AppPanelButton>
            ))}
          </div>
        </AppBottomSheet>
      ) : null}
    </>
  );
}
